/**
 * @generated SignedSource<<58756db4b2e6911a14f6c2fa330eae06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightInfo_segments$data = ReadonlyArray<{
  readonly arrivalDatetime: string;
  readonly departDatetime: string;
  readonly duration: string;
  readonly " $fragmentSpreads": FragmentRefs<"FlightInfoEndpoint_segment" | "FlightInfoFullSegment_segment" | "FlightInfoSegmentInfo_segment">;
  readonly " $fragmentType": "FlightInfo_segments";
}>;
export type FlightInfo_segments$key = ReadonlyArray<{
  readonly " $data"?: FlightInfo_segments$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightInfo_segments">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "FlightInfo_segments",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "arrivalDatetime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "departDatetime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "duration",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightInfoFullSegment_segment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightInfoEndpoint_segment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightInfoSegmentInfo_segment"
    }
  ],
  "type": "FlightSegment",
  "abstractKey": null
};

(node as any).hash = "2459201082feaacf8f1a2d97626a5a6f";

export default node;
